<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store.js';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const store = useStore();

const uiFlags = useMapGetter('integrations/getUIFlags');

const lagoIntegration = computed(() => {
  return store.getters['integrations/getIntegration']('lago', {});
});

const portalUrl = computed(() => {
  const hooks = lagoIntegration.value?.hooks;
  if (hooks && hooks.length > 0) {
    return hooks[0]?.settings?.portal_url || '';
  }
  return '';
});

const isLoading = computed(() => uiFlags.value.isFetching);

onMounted(() => {
  store.dispatch('integrations/get');
});
</script>

<template>
  <div class="flex flex-col h-full w-full bg-n-background">
    <div v-if="isLoading" class="flex items-center justify-center flex-1">
      <Spinner class="text-n-brand" />
    </div>
    <div
      v-else-if="!portalUrl"
      class="flex flex-col items-center justify-center flex-1 gap-2"
    >
      <p class="text-n-slate-11 text-sm">
        {{ t('BILLING_REPORTS.NOT_CONFIGURED') }}
      </p>
    </div>
    <iframe
      v-else
      :src="portalUrl"
      class="flex-1 w-full border-0"
      allow="payment"
      :title="t('BILLING_REPORTS.HEADER')"
    />
  </div>
</template>
